export default function (other) {
  other = other || {};
  return {
    id: other.id || null,

    active: other.active || null,
    name: other.name || null,
    geos: other.geos || null,
  };
}
